(() => {
  if (customElements.get('td-pack-selector')) return;

  class TDPackSelector extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.form = document.getElementById(this.dataset.formId);
      this.variantInput = this.form?.querySelector('[name="id"]');
      this.quantityInput = this.querySelector('[data-td-pack-quantity]');
      this.radios = [...this.querySelectorAll('[data-td-pack-radio]')];
      this.status = this.querySelector('[data-td-pack-status]');

      if (!this.form || !this.variantInput || !this.quantityInput) return;

      this.baseVariantId = String(this.dataset.baseVariantId);

      const first =
        this.radios.find(
          (radio) => radio.dataset.offerSlot === '1' && !radio.disabled
        ) || this.radios.find((radio) => !radio.disabled);

      this.radios.forEach((radio) => {
        radio.checked = radio === first;
      });

      this.onChange = this.handleChange.bind(this);
      this.onSubmit = this.prepareSubmit.bind(this);

      this.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit, true);

      if (first) this.apply(first, false);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('submit', this.onSubmit, true);
    }

    handleChange(event) {
      if (!event.target.matches('[data-td-pack-radio]')) return;
      this.apply(event.target, true);
    }

    prepareSubmit() {
      const selected = this.radios.find((radio) => radio.checked);
      if (selected) this.apply(selected, false);
    }

    apply(radio, announce) {
      const quantity = String(radio.dataset.quantity || '1');
      const variantId =
        radio.dataset.kind === 'product'
          ? String(radio.dataset.variantId)
          : this.baseVariantId;

      this.quantityInput.value = quantity;
      this.variantInput.disabled = false;

      if (String(this.variantInput.value) !== variantId) {
        this.variantInput.value = variantId;
        this.variantInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }

      this.querySelectorAll('[data-td-pack-option]').forEach((option) => {
        option.dataset.selected = String(
          option.querySelector('[data-td-pack-radio]').checked
        );
      });

      if (!announce) return;

      const option = radio.closest('[data-td-pack-option]');
      const label = radio.dataset.label || 'Opción';
      this.status.textContent = `${label} seleccionado.`;

      this.dispatchEvent(
        new CustomEvent('td:pack-selected', {
          bubbles: true,
          detail: {
            productId: String(this.dataset.productId),
            variantId,
            quantity: Number(quantity),
            offerSlot: Number(radio.dataset.offerSlot),
            value: Number(option.dataset.totalCents || 0) / 100,
            currency: this.dataset.currency
          }
        })
      );
    }
  }

  customElements.define('td-pack-selector', TDPackSelector);
})();